import i18n from "@/common/i18n";
/** useCustomMessageBox.js */
import Vue from 'vue';
import to from 'await-to-js';

/**
 * 通用的弹窗use方法
 * @param {*} h 使用传 this.$createElement
 * @param {*} component 自定义messagebox的内容组件
 * @param {*} options 参数
 * @returns
 */
export default async function useCustomMessageBox(h, component, options) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$vhMsgbox({
      title: options?.title || `${i18n.t("lang.k_057001")}`,
      //弹窗标题
      closeOnClickModal: false,
      roundButton: true,
      showCancelButton: true,
      ...options?.messageOptions,
      // 如果有，覆盖
      message: h(component, {
        props: {
          openTs: Date.now(),
          // 打开弹窗时的时间戳,用于监听变化
          ...options?.props
        }
      }),
      beforeClose: async (action, instance, done) => {
        const thatForm = findFormInstance(instance);
        if (!thatForm) {
          reject('The VhForm component is missing');
          done();
          return;
        }
        if (action === 'confirm') {
          const [err, valid] = await to(thatForm.validate());
          if (err || !valid) return;

          // 返回所有表单数据
          resolve(thatForm.model);
          // 确认hook
          if (typeof options?.confirmHook === 'function') options.confirmHook(thatForm.model);
          done();
        } else {
          // 关闭和取消hook
          if (typeof options?.cancelHook === 'function') options.cancelHook(thatForm.model);
          done();
        }
      },
      callback(action, instance) {
        if (action == 'cancel' || action == 'close') {
          reject(action);
        }
      }
    });
  });
}

/**
 * 递归查找子组件树中的第一个 vh-form 实例
 * @param {Vue} parentInstance - 父组件实例
 * @returns {Vue|null} 找到的 vh-form 实例，未找到则返回 null
 */
function findFormInstance(parentInstance) {
  // 检查当前组件是否为 vh-form
  if (parentInstance.$options.name === 'VhForm') {
    return parentInstance;
  }

  // 递归遍历所有子组件
  for (const child of parentInstance.$children) {
    const found = findFormInstance(child);
    if (found) {
      return found;
    }
  }
  return null;
}